import axios from 'axios';
// import { saveAs } from 'file-saver';
import { getAuthHeaders, createAction, toQueryString } from '../../utils/utils';

export const LOAD = '[AlarmsVel] LOAD';
export function load() {
  return { type: LOAD };
}

export const LOAD_SUCCESS = '[AlarmsVel] LOAD_SUCCESS';
export function loadSuccess(data) {
  return { type: LOAD_SUCCESS, data };
}

export const LOAD_FAILED = '[AlarmsVel] LOAD_FAILED';
export function loadFailed(error) {
  return { type: LOAD_FAILED, error };
}
export const LOAD_ONE = '[AlarmsVel] LOAD_ONE';
export function loadOne() {
  return { type: LOAD_ONE };
}

export const LOAD_SUCCESS_ONE = '[AlarmsVel] LOAD_SUCCESS_ONE';
export function loadSuccessOne(data) {
  return { type: LOAD_SUCCESS_ONE, data };
}

export const LOAD_FAILED_ONE = '[AlarmsVel] LOAD_FAILED_ONE';
export function loadFailedOne(error) {
  return { type: LOAD_FAILED_ONE, error };
}

export const EXPORT = '[File] EXPORT';
export function exportDocument() {
  return { type: EXPORT };
}

export const EXPORT_SUCCESS = '[File] EXPORT_SUCCESS';
export function exportSuccess(file) {
  return { type: EXPORT_SUCCESS, file };
}

export const EXPORT_FAIL = '[File] EXPORT_FAIL';
export function exportFailed(error) {
  return { type: EXPORT_FAIL, error };
}

export const VOID = '[AlarmsVel] VOID';
export function emptyRequirement() {
  return { type: VOID };
}

export const UPDATE_ONE = '[AlarmsVel] UPDATE_ONE';
export function updateOne(data) {
  return { type: UPDATE_ONE, data };
}

export const UPDATE_ONE_FAILED = '[AlarmsVel] UPDATE_ONE_FAILED';
export function updateOneFailed(error, id) {
  return { type: UPDATE_ONE_FAILED, error, id };
}

export const UPDATE_ONE_SUCCESS = '[AlarmsVel] UPDATE_ONE_SUCCESS';
export function updateOneSucess(data) {
  return { type: UPDATE_ONE_SUCCESS, data };
}

export const CREATE = '[AlarmsVel] CREATE';
export function create(data) {
  return { type: UPDATE_ONE, data };
}

export const CREATE_SUCCESS = '[AlarmsVel] CREATE_SUCCESS';
export function createSuccess(data) {
  return { type: CREATE_SUCCESS, data };
}

export const CREATE_FAILED = '[AlarmsVel] CREATE_FAILED';
export function createFailed(error) {
  return { type: CREATE_FAILED, error };
}

export const DESTROY = '[AlarmsVel] DESTROY';
export function destroy(data) {
  return { type: DESTROY, data };
}

export const DESTROY_SUCCESS = '[AlarmsVel] DESTROY_SUCCESS';
export function destroySuccess(id) {
  return { type: DESTROY_SUCCESS, id };
}

export const DESTROY_FAILED = '[AlarmsVel] DESTROY_FAILED';
export function destroyFailed(error) {
  return { type: DESTROY_FAILED, error };
}

export function fetchAll(filters = {}) {
  return async function (dispatch, getState) {
    dispatch(load());

    try {
      let url = `${window.config.API_URL_USER}alarmVelReport`;
      // url = `${window.config.API_URL_ORDER}requirements?stateFilter=${stateFilter}`;

      if (Object.keys(filters).length) {
        url = `${url}?${toQueryString(filters)}`;
      }

      const res = await axios.get(url, {
        headers: getAuthHeaders(getState()),
      });

      if (res.status === 201) {
        dispatch(loadSuccess(res.data.data));
      } else {
        dispatch(loadFailed(res.data.message));
      }
    } catch (err) {
      dispatch(loadFailed(err));
    }
  };
}

export function exportFile(filters = {}) {
  return async function (dispatch) {
    dispatch(exportDocument());

    try {
      let url = `${window.config.API_URL_USER}alarmVelReport/export`;

      if (Object.keys(filters).length) {
        url = `${url}?${toQueryString(filters)}`;
      }

      const res = await axios.get(url, {
        headers: {
          // Authorization: 'Bearer'
        },
      });

      if (res.status === 200) {
        // saveAs(res.config.url, `Reporte Alarma de Velocidad`);

        dispatch(exportSuccess(res.data.data));
      } else {
        dispatch(exportFailed(res.error));
      }
    } catch (error) {
      dispatch(exportFailed(error));
    }
  };
}
